import React, { useEffect } from "react";
import { useHistory } from "react-router";

import CompanyInfo from "pages/dashboard/CompanyInfo";

import ProfitAndLoss from "pages/dashboard/ProfitAndLoss";
import BalanceSheet from "pages/dashboard/BalanceSheet";
import CashFlow from "pages/dashboard/CashFlow";

import PriceAndVolumeChart from "pages/dashboard/PriceAndVolumeChart";
import PeAndPbChart from "pages/dashboard/PeAndPbChart";

import Brand from "pages/dashboard/Brand";

import CompanyEssential from "pages/dashboard/CompanyEssential";

import IndexPresence from "pages/dashboard/IndexPresence";

import PeerComparison from "pages/dashboard/PeerComparison";

import RatioChart from "pages/dashboard/RatioChart";

import DuPont from "pages/dashboard/DuPont";

import DCFAnalysis from "pages/dashboard/DCFAnalysis";
import EMAAnalysis from "pages/dashboard/EMAAnalysis";
import BVPSAnalysis from "pages/dashboard/BVPSAnalysis";

import * as Actions from "../state/Actions"
import { navBarList, constants } from "utils/Constant";

import {
  Row,
  Col,
} from "reactstrap";

import ProsAndCons from "pages/dashboard/ProsAndCons";
import RatiosTable from "pages/dashboard/RatiosTable";
import { Container } from "@mui/system";

const Dashboard = () => {
  const history = useHistory()
  const Params = Actions.UTILS.getQueryParams(history.location.search)

  useEffect(() => {
    history.push(`${constants.finalyze}/?company__name=` + encodeURIComponent(Params.company__name) + '&company__symbol=' + encodeURIComponent(Params.company__symbol))
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
      inline: "nearest"
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Params.company__symbol]);


  return (
    <Container maxWidth="xl">
      <div id={navBarList[0].id}>
        <CompanyInfo />
        <CompanyEssential />
        <RatioChart />

      </div>

      <div id={navBarList[1].id}>
        <ProsAndCons />
      </div>

      <div id={navBarList[2].id}>
        <ProfitAndLoss period={"Y"} title={"Profit & Loss"} />
      </div>

      <div id={navBarList[3].id}>
        <ProfitAndLoss period={"QA"} title={"Quarterly Results"} />
      </div>

      <div id={navBarList[4].id}>
        <BalanceSheet />
      </div>

      <div id={navBarList[5].id}>
        <CashFlow />
      </div>

      <div id={navBarList[6].id}>
        <Row>
          <Col md="12">
            <PriceAndVolumeChart />
          </Col>
          <Col md="12">
            <PeAndPbChart />
          </Col>
        </Row>
      </div>

      <div id={navBarList[7].id} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16, alignItems: 'stretch' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Brand style={{ flex: 1 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <IndexPresence style={{ flex: 1 }} />
        </div>
      </div>

      <div id={navBarList[8].id}>
        <PeerComparison />
      </div>

      <div id={navBarList[9].id}>
        <RatiosTable />
      </div>

      <div id={navBarList[10].id}>
        <DuPont />
      </div>

      <div id={navBarList[11].id}>
        {/* Fair Value section header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 12,
        }}>
          <span style={{
            fontFamily: "'Bricolage Grotesque', sans-serif",
            fontSize: 16,
            fontWeight: 700,
            color: '#232821',
          }}>Fair Value</span>
        </div>
        <Row xs={1} md={1} className="mb-3">
          <Col>
            <DCFAnalysis />
          </Col>
        </Row>
        <Row xs={1} md={2}>
          <Col>
            <EMAAnalysis />
          </Col>
          <Col>
            <BVPSAnalysis />
          </Col>
        </Row>
      </div>

    </Container>
  );
}
export default Dashboard;